import { Step1CmdrsData } from '../steps/step1';
import { Step2CmdrsData } from '../steps/step2';
import { Step3CmdrsData } from '../steps/step3';
import { Step4CmdrsData } from '../steps/step4';
import { Step5CmdrsData } from '../steps/step5';

interface MapToCreateCmdrsDtoParams {
    step1: Step1CmdrsData;
    step2: Step2CmdrsData;
    step3: Step3CmdrsData;
    step4: Step4CmdrsData;
    step5: Step5CmdrsData;
    institution_uuid?: string;
    pacote_formularios_uuid?: string;
    package_status?: number;
}

export function mapToCreateCmdrsDto({
    step1,
    step2,
    step3,
    step4,
    step5,
    package_status
}: MapToCreateCmdrsDtoParams) {
    if (!step1.hasCmdrs) {
        return {
            has_cmdrs: step1.hasCmdrs,
        }
    }

    return {
        has_cmdrs: step1.hasCmdrs,
        instrument: step1.instrument,
        instrument_number: step1.instrumentNumber,
        publication_date: step1.publicationDate,
        document_uuid: step1.document_uuid ?? undefined,
        status: step1.status,
        structure: step1.structure,
        presiding_institution: step1.presidingInstitution,
        mandate_end: step1.mandateEnd,
        qtd_poder_publico: step1.qtdPoderPublico,
        qtd_sociedade_civil: step1.qtdSociedadeCivil,

        members: step2.members?.map(member => ({
            role: member.role,
            bond: member.bond,
            institution: member.institution,
            name: member.name,
            start: member.start,
            end: member.end,
            phone: member.phone,
            mobile: member.mobile,
            email: member.email,
        })),

        existing_councils: step3.existingCouncils,
        other_existing_council: step3.otherExistingCouncil,
        seated_councils: step3.seatedCouncils,
        other_seated_council: step3.otherSeatedCouncil,
        is_consortium_member: step3.isConsortiumMember,
        participates_activities: step3.participatesActivities,
        activities_description: step3.activitiesDescription,
        has_susaf: step3.hasSusaf,

        selected_challenges: step4.selectedChallenges,
        challenges_order: step4.challengesOrder?.map(item => ({
            value: item.value,
            order: item.order,
        })),
        other_challenge: step4.otherChallenge,

        demands: step5.demands?.map(demand => ({
            object: demand.object,
            quantity: demand.quantity,
            justification: demand.justification,
        })),

        package_status: package_status ?? null
    };
}